import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/authentication.service'
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public errors = null;
  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      'email': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required])
    });
  }

  get f(){
    return this.loginForm.controls;
  }

  login() {

    this.authenticationService.SignIn(this.f.email.value, this.f.password.value, 'admin')
      .catch(err => {
        switch(err.code){
          case "auth/wrong-password":
            this.errors = "Error: La contraseña no es correcta.";
            break;
          case "auth/user-not-found":
            this.errors = "Error: Los datos proporcionados no coinciden.";
            break;
          case "auth/invalid-email":
            this.errors = "Error: El email no cumple con el formato requerido.";
            break;
          default:
            this.errors = "Error: Email y/o contraseña no válido.";
        }
      });
  }

}
